/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import _ from 'lodash';

import './styles/tooltips.scss';
import { StatLabel } from '../stat/stat-label';
import StatStacked from '../stat/stat-container-stacked';
import { StatContainerBBK } from '../stat/stat-container-bbk';
import TipBoldLabel from './bold-label-tooltip';

type Stat =
  | (React.ComponentProps<typeof StatStacked> & {
      statContainerType: 'StatStacked';
    })
  | (React.ComponentProps<typeof StatContainerBBK> & {
      statContainerType: 'BBKStat';
    });

type Props = {
  tipTitle?: React.ComponentProps<typeof TipBoldLabel>;
  stats?: Stat[];
  bottomInfo?: {
    label: React.ComponentProps<typeof StatLabel>['label'];
    text: React.ComponentProps<typeof TipBoldLabel>['text'];
  };
};
export const InnerTooltipDetailHTML: React.FC<Props> = (props) => {
  const { tipTitle, stats, bottomInfo } = props;

  const renderStat = (stat: Stat, index: number) => {
    if (stat.statContainerType === 'StatStacked') {
      return <StatStacked {...stat} key={index} />;
    }
    if (stat.statContainerType === 'BBKStat') {
      return <StatContainerBBK {...stat} key={index} />;
    }
    return undefined;
  };
  return (
    <div className="tip-container">
      {!_.isNil(tipTitle) && <TipBoldLabel {...tipTitle} />}
      <div className="tc-top">{stats?.map(renderStat)}</div>
      {!_.isNil(bottomInfo) && (
        <div className="tc-bottom">
          <StatLabel label={bottomInfo.label} />
          <TipBoldLabel text={bottomInfo.text} />
        </div>
      )}
    </div>
  );
};
